// A 4x2 collection of pops.
// Used for starting/stopping something, like the grabber tool on the Whimsical Animations landing page.
import * as React from 'react';

import { sampleOne } from '@/utils';
import useSound from '@/hooks/use-sound';

const SPRITES: Record<string, [number, number]> = {
  high1: [0, 400],
  high2: [500, 400],
  high3: [1000, 400],
  high4: [1500, 400],
  low1: [2000, 400],
  low2: [2500, 400],
  low3: [3000, 400],
  low4: [3500, 400],
};

export default function useGrabSfx() {
  const [lowLevelPlayFn] = useSound('/sounds/pops-grabber-tool.mp3', {
    volume: 0.2,
    sprite: SPRITES,
  });

  const playStart = React.useCallback(() => {
    lowLevelPlayFn({
      id: sampleOne(['high1', 'high2', 'high3', 'high4']),
    });
  }, [lowLevelPlayFn]);

  const playStop = React.useCallback(() => {
    lowLevelPlayFn({
      id: sampleOne(['low1', 'low2', 'low3', 'low4']),
    });
  }, [lowLevelPlayFn]);

  return [playStart, playStop];
}
